import React, { useEffect, useState } from 'react';
import { JsonViewer } from '@textea/json-viewer';
import { Category, TenantHierarchy } from '@app/models';
import { findOuById, useAggregatedConfigRule } from '@app/sdk';
import { ComponentErrorBoundary } from '@app/utilities';

export function addCategoryAndOuNamesToRules(rules: any[], categories: Category[], tenantHierarchy: TenantHierarchy) {
  return rules?.map((rule) => {
    return {
      categoryName: categories?.find((c) => c.id === rule.category)?.description,
      organisationUnitName: findOuById(tenantHierarchy.organisationUnit, rule.organisationUnitId)?.name,
      ...rule,
    };
  });
}

export function AggregatedConfigRules({
  ouId,
  categoryId,
  categories,
  tenantHierarchy,
}: {
  ouId: string;
  categoryId: string;
  categories: Category[];
  tenantHierarchy: TenantHierarchy;
}) {
  const [filteredRules, setFilteredRules] = useState(undefined as any);
  const { data: rules, isLoading } = useAggregatedConfigRule({ ouId });

  useEffect(() => {
    const rulesWithCategoryAndOuNames = addCategoryAndOuNamesToRules(rules, categories, tenantHierarchy);
    setFilteredRules(
      rulesWithCategoryAndOuNames?.filter((rule: any) => categoryId === 'all' || rule.category === categoryId)
    );
  }, [categoryId, rules, categories, tenantHierarchy, ouId]);

  return (
    <ComponentErrorBoundary>
      {isLoading && <div className="ui active centered inline loader" />}
      {!isLoading && filteredRules && <JsonViewer value={filteredRules} />}
    </ComponentErrorBoundary>
  );
}
